<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="600px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px">
            <el-form-item label="部门名称" prop="departName">
                <el-input type="text" v-model="dataForm.departName" style="width: 90%;" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {Depart} from "../../api/depart";

    export default {
        name: "depart-add-or-update",
        data() {
            return {
                visible: false,
                dataForm: {
                    id: 0,
                    departName: ''
                },
                dataRule: {
                    departName: [
                        {required: true, message: '部门名称不能为空', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.visible = true;
                this.dataForm.id = id;
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                });
                if (this.dataForm.id) {
                    Depart.getDepartInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.departName = res.depart.departName;
                        }
                    })
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'departName': this.dataForm.departName
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        Depart.addOrUpdateDepart(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
